import type { Tokens } from '../../../../theming/types'
import type { MenuUIProps } from '..'

export default (config: {
  props: Pick<MenuUIProps, 'positionStatic'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    menuUIContainer: {
      borderRadius: !props.positionStatic ? '2px' : undefined,
    },

    menuUIBackground: {
      boxShadow: !props.positionStatic ? tokens.elevationMedium : undefined,
      backgroundColor: !props.positionStatic
        ? tokens.bgColorDefault
        : undefined,
      border: !props.positionStatic ? '1px solid #cccccc' : undefined,
      borderRadius: '2px',
    },

    menuUIMenuItems: {
      border: props.positionStatic ? '1px solid #cccccc' : undefined,
      borderRadius: props.positionStatic ? tokens.radiusSizeXS : undefined,
      padding: '0 1px',
    },
  } as const
}
